// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Payload widths a read accepts.
 */
export enum Widths {
  W1 = 1,
  W2 = 2,
  W4 = 4,
  W8 = 8,
}
